import { Component, Input } from '@angular/core';

import { ChartTooltipModel } from '../typings/intelligence.chart-tooltip';

@Component({
  selector   : 'wor-intelligence-chart-tooltip',
  template: require('./intelligence.chart-tooltip.component.html')
})
export class ChartTooltipComponent {
  @Input() model : ChartTooltipModel;
}
